module.exports = __webpack_public_path__ + "static/media/2Key_symbol.bac129500f1165fac7c0b3cfccda3d1b.svg";